import React, { useCallback, useMemo } from 'react';
import { Form, Select } from 'src/common';
import { useTranslation } from 'react-i18next';
import { AwardStatus } from '@tendium/prom-types';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { SupplierOrg, SupplierString } from 'src/models/procurements/Tenders/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import styles from './index.module.scss';

interface SupplierStatusDropdownProps {
  value: AwardStatus;
  statusKey: string;
}

const SupplierStatusDropdown: React.FC<SupplierStatusDropdownProps> = ({ value, statusKey }) => {
  const { t } = useTranslation();
  const [{ vars: searchArgs }, updateSearchArgs] = useApiTenders();

  const updatedSupplierOrgs: SupplierOrg[] = useMemo(
    () => [...(searchArgs?.supplierOrgIds ?? [])],
    [searchArgs?.supplierOrgIds]
  );
  const updatedSupplierStrings: SupplierString[] = useMemo(
    () => [...(searchArgs?.supplierSearchStrings ?? [])],
    [searchArgs?.supplierSearchStrings]
  );

  const handleStatusChange = useCallback(
    (newStatus: AwardStatus) => {
      if (statusKey.includes('-prefixsearch')) {
        const id = statusKey.replace('-prefixsearch', '');
        let updateObj = updatedSupplierStrings.find(e => e.orgName === id);

        if (updateObj) {
          updateObj = { ...updateObj };
          updateObj.status = newStatus;

          updateSearchArgs({
            supplierSearchStrings: [...updatedSupplierStrings.filter(curr => id !== curr.orgName), updateObj]
          });
        }
      } else {
        const id = statusKey;
        let updateObj = updatedSupplierOrgs.find(e => e.orgId === id);

        if (updateObj) {
          updateObj = { ...updateObj };
          updateObj.status = newStatus;

          updateSearchArgs({
            supplierOrgIds: [...updatedSupplierOrgs.filter(curr => id !== curr.orgId), updateObj]
          });
        }
      }
    },
    [statusKey, updatedSupplierStrings, updateSearchArgs, updatedSupplierOrgs]
  );

  return (
    <Form.Item name={statusKey} initialValue={value}>
      <Select
        onChange={handleStatusChange}
        optionLabelProp={'label'}
        value={value}
        className={styles.select}
        suffixIcon={<FontAwesomeIcon className={styles.selectIcon} icon={faCaretDown} />}
      >
        <Select.Option value={AwardStatus.Won} label={t('ExpiringContracts.supplierStatusWinning')}>
          {t('ExpiringContracts.supplierStatusWinning')}
        </Select.Option>
        <Select.Option value={AwardStatus.NotWon} label={t('ExpiringContracts.supplierStatusNotWinning')}>
          {t('ExpiringContracts.supplierStatusNotWinning')}
        </Select.Option>
        <Select.Option value={AwardStatus.All} label={t('ExpiringContracts.supplierStatusAll')}>
          {t('ExpiringContracts.supplierStatusAll')}
        </Select.Option>
      </Select>
    </Form.Item>
  );
};

export default SupplierStatusDropdown;
